import React from 'react';
import { Grid, Hidden, IconButton } from '@material-ui/core';
import { ArrowLeft } from 'react-feather';

import { SubTitle3Text, SubTitle1Text } from '../../TextVariants';
import { colors } from '../../../theme';
import PercentBar from '../PercentBar';

type HeaderWithPercentBarProps = {
  id?: string;
  icon?: React.ReactNode;
  currentProgress: number;
  stepperTitle: string | React.ReactNode;
  stepperSubtitle?: string;
  titleStyles?: React.CSSProperties;
  subtitleStyles?: React.CSSProperties;
  progressColor?: string;
  goToBackPage?: () => void;
};

const HeaderWithPercentBar = ({
  id = 'back-button',
  icon = <></>,
  goToBackPage,
  currentProgress,
  stepperTitle,
  stepperSubtitle,
  progressColor = colors.bright_turquoise,
  titleStyles = {},
  subtitleStyles = {},
}: HeaderWithPercentBarProps): JSX.Element => {
  return (
    <Grid container spacing={2} data-testid="containerId">
      <Grid
        item
        container
        xs={12}
        direction="row"
        justifyContent="center"
        alignItems="center"
        spacing={2}
      >
        <Grid item data-testid="iconId" style={{ display: 'flex' }}>
          {/* Mobile Arrow Icon */}
          {goToBackPage && (
            <Hidden mdUp>
              <div style={{ marginRight: 10 }}>
                <IconButton id={id} onClick={goToBackPage}>
                  <ArrowLeft />
                </IconButton>
              </div>
            </Hidden>
          )}
          {icon}
        </Grid>
        <Grid item xs>
          <SubTitle1Text style={titleStyles} data-testid="stepperTitleId">
            {stepperTitle}
          </SubTitle1Text>
          {stepperSubtitle && (
            <SubTitle3Text
              style={subtitleStyles}
              data-testid="stepperSubtitleId"
            >
              {stepperSubtitle}
            </SubTitle3Text>
          )}
        </Grid>
      </Grid>
      <Grid item xs={12}>
        <PercentBar
          fillPercent={currentProgress}
          animatesChanges
          barColor={progressColor}
          data-testid="percentBarId"
        />
      </Grid>
    </Grid>
  );
};

export default HeaderWithPercentBar;
